import { render } from "./moduleShop.vue?vue&type=template&id=4c2d22f0"
import script from "./moduleShop.vue?vue&type=script&lang=js"
export * from "./moduleShop.vue?vue&type=script&lang=js"

import "./moduleShop.vue?vue&type=style&index=0&id=4c2d22f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__